"use client";

import { Modal } from "@/components/ui/modal/index";
import React from "react";

export default function InlineCreateModal({
  title,
  isOpen,
  onClose,
  children,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className="max-w-lg w-full p-0">
      <div className="border-b border-gray-800 px-5 py-4">
        <h2 className="text-sm font-semibold text-white">{title}</h2>
      </div>
      <div className="px-5 py-4 max-h-[70vh] overflow-y-auto">{children}</div>
    </Modal>
  );
}
